<template>
  <div style="width:100%;height:100%;">
    <pull-to :id="'works-' + mod + '-container'" :style="listStyle" class="my-list" :top-load-method="(loaded) => loadData(loaded, showUp ? 'up' : 'renew')" :bottom-load-method="(loaded) => loadData(loaded, 'down')" @infinite-scroll="getData('down')">
      <div class="flow-container">
        <div v-for="(column, index) in columns" :key="index" class="column" :style="{'width': columnWidth + 'px' }">
          <div v-for="(item, i) in column.items" :key="i" class="item">
            <div class="card" :style="{ 'width': cardWidth + 'px', 'height': (item._height - 5) + 'px' }">
              <div>
                <img :src="worksHost + 'work/action/download/gridy/size/8/shape/none/workid/' + item.workid + '/' + item.name + '.png?ver=' + (item.update_at || item.add_at)" :class="{'round-top': cardWidth - 16 < item._raw_width}" :style="{ width: item._raw_width + 'px', height: item._raw_height + 'px' }" @click="openViewer(params.isBricky ? 1: 0, item.userid, item.workid)">
                <div class="title">
                  <div class="left">
                    <span v-if="!item.check" class="tag bg-red white">{{ $t('i.lockUp') }}</span>
                    <!-- <span v-if="item.original" class="tag">{{ $t('i.origin') }}</span> <span v-if="item.best" class="tag">{{ $t('i.recomman') }}</span> -->
                    {{ item.name }}
                  </div>
                  <div class="right">
                    <el-button class="tap-btn" @click="showActionSheet(item)">
                      <i class="iconfont my-dot-more-v" />
                    </el-button>
                  </div>
                </div>
                <div class="foot">
                  <div class="left" @click="emit('goto', ['user', { userid: item.userid } ])">
                    <span v-if="!users[item.userid].avatar" class="el-avatar el-avatar--circle noavatar small">
                      <i class="iconfont my-man" />
                    </span>
                    <el-avatar v-if="users[item.userid].avatar" :size="24" :src="getAvatar(item)" />
                  </div>
                  <div class="center ellipsis" style="width:calc(100% - 100px);" @click="emit('goto', ['user', { userid: item.userid } ])">
                    {{ (users[item.userid]) ? users[item.userid].nickname : view.anonymity }}
                  </div>
                  <div class="right">
                    <el-button v-if="mod === 'favor'" class="tap-btn" @click="() => unfavorIt(item.workid)">
                      <i class="iconfont my-star" />
                    </el-button>
                    <el-button v-if="mod !== 'favor'" class="tap-btn" @click="() => praiseIt(item.workid)">
                      <i class="iconfont" :class="{ 'my-praise-fill': state.praiseState[item.workid], 'my-praise-blank': !state.praiseState[item.workid] }" />
                    </el-button>
                  </div>
                  <div class="right">
                    <span v-if="mod === 'favor'">{{ state.favorState[item.workid] && state.favorState[item.workid] > 0 ? formateNums(state.favorState[item.workid]) : '' }}</span>
                    <span v-if="mod !== 'favor'">{{ state.praiseCount[item.workid] && state.praiseCount[item.workid] > 0 ? formateNums(state.praiseCount[item.workid]) : '' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="itemNums && !data.noDownPage" class="tip load" @click="getData('down')"><i class="iconfont my-dot-more" /></div>
      <div v-if="flowHeight > height && data.noDownPage" class="tip">{{ $t('i.showAll') }}</div>
      <el-empty v-if="(!itemNums && !loading[mod])" :image="emptyImage" :description="$t('i.none')" />
    </pull-to>
    <div v-if="data.scrollTop > 200" class="go-top">
      <el-button class="tap-btn" @click="backTop()">
        <i class="iconfont my-top" />
      </el-button>
    </div>
  </div>
</template>
<script>
import { mixins } from '@/mixins/works'
export default {
  mixins: [mixins]
}
</script>
